var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#9E9E9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8825 16.2925C10.2725 16.6825 10.9025 16.6825 11.2925 16.2925L18.8725 8.7025C19.2625 8.3125 19.2625 7.6825 18.8725 7.2925C18.4825 6.9025 17.8525 6.9025 17.4625 7.2925L10.5825 14.1725L7.7025 11.2925C7.3125 10.9025 6.6825 10.9025 6.2925 11.2925C5.9025 11.6825 5.9025 12.3125 6.2925 12.7025L9.8825 16.2925Z",
    fill: "#9E9E9E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDisabled);
export default __webpack_public_path__ + "static/media/select-disabled.c953b5bc6ddb73f12e3976e852e09738.svg";
export { ForwardRef as ReactComponent };